import { Component, OnInit, Renderer2, ElementRef } from "@angular/core";
import { ConsumeAPIService } from "../../Services/rest-api.service";
import { environment } from "src/environments/environment";
import { Router } from "@angular/router";
import { SidenavListComponent } from "../../navigation/sidenav-list/sidenav-list.component";
import { NgxSpinnerLoaderService } from "@app/services/ngx-spinner.service";
import { AuthService } from "../../Layout/auth/auth.service";
import { CommonMethodsService } from "../../Services/common-methods.service";
import { MatDialog } from "@angular/material/dialog";
import { DataService } from "../../Services/data.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.scss"],
})
export class HomeComponent implements OnInit {
  rows = [];
  rowsString = "";
  profile: any = {};
  userAccess;
  APIobservable;
  APIresult;
  loaderBoolean = false;
  temp = [];
  homeLoaded: string;
  appList = [];
  impersonateID = "";
  isImpersonatID = false;
  isImpersonateProdID = false;
  devEnv = false;
  currentUser = "";
  pageTitle = "";
  navItems = [];

  constructor(
    private API: ConsumeAPIService,
    private router: Router,
    private sidenav: SidenavListComponent,
    private spinnerService: NgxSpinnerLoaderService,
    public auth: AuthService,
    public commFun: CommonMethodsService,
    private renderer: Renderer2,
    private el: ElementRef,
    public dialog: MatDialog,
    private data: DataService
  ) {
    API.setendpoint(null);
  }

  ngOnInit() {
    // SET HIGH LEVEL PAGE HEADER, SIDEBAR MENU VALUES
    this.data.showSideBarStatus(false);
    this.data.showSidebarValue(false);
    this.data.changeTitle("");
    this.data.changeSidebarValues(JSON.stringify(""));

    localStorage.setItem("userData", "");
    localStorage.setItem("sidenavLoaded", "no");
    this.data.showSideBarStatus(false);

    let idtoken = localStorage.getItem("id_token");
    setTimeout(() => {
      if (idtoken === null) {
        idtoken = localStorage.getItem("IdToken");
        // console.log('home - idtoken', idtoken);
        if (idtoken) {
          localStorage.setItem("id_token", idtoken);
        } else {
          return;
        }
      }

      // console.log('home - idtoken2', idtoken);
      if (idtoken) {
        // console.log('idtoken found ', idtoken);
        var idTokenDecoded = atob(idtoken.split(".")[1]);

        // Converts string tokens to JSON
        var idTokenJson = JSON.parse(idTokenDecoded);
        this.profile = idTokenJson;
        console.log('Home: this.profile', this.profile);
        localStorage.setItem("UserProfile", this.profile);

        this.getUserIDAndLoadMenu();

        // setTimeout(() => {
        //   this.testAPI2();
        // }, 200);
      }
    }, 200);
  }



  async getUserIDAndLoadMenu() {
    this.spinnerService.show();
    this.isImpersonateProdID = this.isUserInpersonateProdMember(
      this.profile.name
    );
    if (
      environment.siteenv == "dev" ||
      environment.siteenv == "uat" ||
      (environment.siteenv == "prod" && this.isImpersonateProdID)
    ) {
      this.devEnv = true;
      if (
        localStorage.getItem("ImpersonateID") != "" &&
        localStorage.getItem("ImpersonateID") != null
      ) {
        this.impersonateID = localStorage.getItem("ImpersonateID");
      }
      if (this.impersonateID != "") {
        localStorage.setItem("userGlobalID", this.impersonateID);
        this.currentUser = this.impersonateID;
      } else {
        localStorage.setItem("userEmailAddress", this.profile.email);
        // NNED TO IMPLEMENT HIDING OF COVID-19 APP IF USER IS NOT AUTHORIZED
        // localStorage.setItem("userGlobalID", this.profile.name);
        // this.currentUser = this.profile.name;

        console.log("000 this.profile values: ", this.profile);
        let useremailid = this.profile['cognito:username'];
        console.log("email id: ", useremailid.substring(useremailid.indexOf("_") + 2));

        let userid = this.profile['cognito:username'];
        // let userid = 'KW3257';
        localStorage.setItem("userGlobalID", userid);
        this.currentUser = userid;


      }
    } else {
      this.devEnv = false;

      console.log("111 this.profile values: ", this.profile);
      let cognitoUserName = this.profile['cognito:username'];
      let useremailid = cognitoUserName.substring(cognitoUserName.indexOf("_") + 1)
      console.log("email id: ", useremailid);

      localStorage.setItem("userEmailAddress", this.profile.email);
      // NNED TO IMPLEMENT HIDING OF COVID-19 APP IF USER IS NOT AUTHORIZED
      // localStorage.setItem("userGlobalID", this.profile.name);

      let userid = this.profile['cognito:username'];

      if (cognitoUserName.indexOf("skf-vertevo-email-users-sign-in") >= 0) {
        userid = useremailid;
        localStorage.setItem("userEmailAddress", useremailid);
      }

      // let userid = 'KW3257';
      localStorage.setItem("userGlobalID", userid);
      this.currentUser = userid;
    }

    // NNED TO IMPLEMENT HIDING OF COVID-19 APP IF USER IS NOT AUTHORIZED
    let userid = localStorage.getItem("userGlobalID");
    // let userid = 'FH2121';

    if (userid != null) {
      // get menu and access info for the user and build menu

      this.APIobservable = this.API.get(
        "getData?app=Common&type=getUserMenuData&userID=" + userid
      );
      this.APIobservable.subscribe(async (resp) => {
        this.spinnerService.hide();
        // IF RESPONSE DOES NOT CONTAIN SUCCESS CODE AND MESSAGE THEN SHOW ERROR
        if (typeof resp.status === undefined || resp.status != 200) {
          this.commFun.openDialog(environment.dataRetrieveError, "Warning");
          return false;
        }

        this.APIresult = resp.result;
        this.rows = resp.result;

        if (this.rows.length > 0) {
          let allappdetails = environment.applicationDetails;
          let appdetails;
          let record;
          let appname = "";

          for (let i = 0; i < this.rows.length; ++i) {
            record = this.rows[i];
            appname = record.ApplicationName;

            let appnameroute = appname.replace(/\s/g, "-");
            appdetails = allappdetails[appnameroute.toLowerCase()];
            if (appdetails) {
              this.appList.push({
                name: appname,
                hoverName: appname,
                hoverStatus: false,
                route: "/" + appnameroute.toLowerCase(),
                icon: appdetails.logo,
                hoverIcon: appdetails.hoverIcon,
                desc: record.ApplicationDescription,
              });
            }
          }
        }
      });
    }
  }

  showErrorMessage() {
    this.renderer.setProperty(
      this.el.nativeElement,
      "innerHTML",
      "<h5>" + environment.dataErrorMessage + "</h5>"
    );
  }

  async navigateToPath(routeValue: any) {
    // console.log(routeValue);
    if (routeValue.substr(1) === "illuminateapp") {
      window.open(environment.illuminateMainAppURL, "_blank");
      return true;
    }
    console.log('route valueeeeee', routeValue.substr(1));
    let allappdetails = environment.applicationDetails;
    let appdetails = allappdetails[routeValue.substr(1)];
    localStorage.setItem("appname", appdetails.applicationName);
    localStorage.setItem("routerappname", routeValue.substr(1));

    let appname = appdetails.applicationName;
    let userid = localStorage.getItem("userGlobalID");

    if (userid != null && userid != undefined) {
      // set the Rep data to null in home page
      localStorage.setItem("userData", "");

      this.spinnerService.show();
      this.APIobservable = this.API.get("getData?app=Common&type=getUserData&userID=" + userid + "&applicationName=" + appname);
      this.APIobservable.subscribe(async (resp) => {
        this.spinnerService.hide();
        // IF RESPONSE DOES NOT CONTAIN SUCCESS CODE AND MESSAGE THEN SHOW ERROR
        if (typeof resp.status === undefined || resp.status != 200) {
          this.commFun.openDialog(environment.dataRetrieveError, "Warning");
          return false;
        }

        this.APIresult = resp.result;
        this.rows = resp.result;

        this.sidenav.loaderBoolean = false;
        localStorage.setItem("userData", JSON.stringify(this.rows));

        this.router.navigate([routeValue]);
      });
    }
    else {
      // FOR SOME REASON USERID IS NOT SET YET THEN ROUTE BACK TO HOME TO USER DETAILS
      this.router.navigate(['/']);
    }
  }

  signoutUser() {
    this.auth.signOut().then(() => this.router.navigate(["/"]));
  }

  selectImpersonateUser() {
    this.isImpersonatID = true;
    this.devEnv = false;
  }

  onChangeValue() {
    this.isImpersonatID = false;
    this.devEnv = true;
    localStorage.setItem("ImpersonateID", this.impersonateID);
    window.location.reload();
  }

  onClearValue() {
    this.isImpersonatID = false;
    this.devEnv = true;
    localStorage.setItem("ImpersonateID", "");
    this.impersonateID = "";
    window.location.reload();
  }

  isUserInpersonateProdMember(userID: string): boolean {
    let isUserImpersonate = false;
    var imporsonateMember = environment.impersonateUsers; //  "AB12,BC23,BH767";
    var users = imporsonateMember.split(",");
    for (let i = 0; i < users.length; i++) {
      if (userID === users[i]) {
        isUserImpersonate = true;
      }
    }
    return isUserImpersonate;
  }
}
